const tableStyles = {
  scrollContainer: {
    overflowX: "auto",
    overflowY: "auto",
    width: "100%",
    maxHeight: "calc(100vh - 200px)",
    padding: 0,
  },
  table: {
    minWidth: "1200px",
    width: "100%",
    marginTop: "4px",
    marginBottom: "4px",
    textAlign: "center",
  },
  active: {
    backgroundColor: "rgb(42, 98, 151)",
    color: "white",
  },
  spinContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "200px",
  },
  td: {
    fontSize: "13px",
    fontWeight: "normal",
    color: "black",
  },
  tr: {
    verticalAlign: "middle",
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  imgContainer: {
    dispay: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: "8px",
  },
  img: {
    width: "120px",
  },
  noDataLbl: {
    textAlign: "center",
  },
  dateHdrCell: {
    border: "1px solid lightgrey",
    textAlign: "center",
    verticalAlign: "middle",
    whiteSpace: "normal",
    wordWrap: "break-word",
    width: "280px",
    minWidth: "280px",
    maxWidth: "280px",
    fontSize: "13px",
    position: "sticky",
    top: 0,
    zIndex: 10,
    backgroundColor: "rgb(42, 98, 151)",
    color: "white",
  },
  headerCell: {
    border: "1px solid lightgrey",
    textAlign: "center",
    verticalAlign: "middle",
    whiteSpace: "normal",
    wordWrap: "break-word",
    width: "130px",
    minWidth: "130px",
    maxWidth: "130px",
    fontSize: "13px",
    position: "sticky",
    top: 0,
    zIndex: 10,
    backgroundColor: "rgb(42, 98, 151)",
    color: "white",
  },
  tfoot: {
    border: "1px solid #ddd",
  },
  tfootTabledata: {
    fontWeight: "bold",
    fontSize: "13px",
    padding: "5px 1px",
  },
  spanArr: {
    marginRight: "8px",
    display: "inline-block",
  },
};
export default tableStyles;
